import { Component, Input, OnInit } from '@angular/core';
import { FileWorker } from '../../common/utils/common';
import { FileService } from '../../common/services/File.service';

@Component({
  selector: 'file-viewer',
  templateUrl: './file-viewer.component.html',
  styleUrls: ['./file-viewer.component.css'],
  providers: [FileService],
})
export class FileViewerComponent implements OnInit {
  @Input() fileUrl: string;
  @Input() email_msg_id: string;
  @Input() accept_download = false;
  @Input() display_image = false;
  fileName: string;
  fileSize: string;
  fileIcon: string;
  bgColor: string;
  isImage = false;
  isLoading = true;
  showMark = false;

  protected readonly fileWorker = new FileWorker();
  constructor(private fileService: FileService) {}
  ngOnInit(): void {
    this.fetchFileName();
  }

  fetchFileName(): void {
    this.fileService.determineLinkType(this.fileUrl).subscribe(res => {});
    // this.fileService.postGetFileLink(this.fileUrl).subscribe(
    //   response => {
    //     console.log(response);
    //   }, err => {
    //     console.error('Failed to fetch file:', err);
    //   });
    this.fileService.getFileLink(this.fileUrl).subscribe(
      response => {
        this.fileSize = this.fileWorker.formatBytes(response.body.size);
        this.fileIcon = this.getFileIcon(this.fileService.getFileExtension(response.body.type));
        this.bgColor = this.getClassColor(this.fileService.getFileExtension(response.body.type));
        const contentDisposition = response.headers.get('Content-Disposition');
        if (contentDisposition) {
          const matches = /filename="([^"]*)"/.exec(contentDisposition);
          this.fileName =
            matches != null && matches[1]
              ? matches[1]
              : this.fileWorker.formatNameFile(this.generateFileName(response.body));
        } else {
          this.fileName = this.fileWorker.formatNameFile(this.generateFileName(response.body));
        }
        this.isLoading = false;
      },
      error => {
        this.fileIcon = this.getFileIcon('');
        this.fileName = this.fileWorker.formatNameFile(this.fileUrl);
        console.error('Failed to fetch file:', error);
        this.isLoading = false;
      }
    );
  }

  generateFileName(file): string {
    let name = this.fileUrl.split('/').pop();
    const fileExtension = this.fileService.getFileExtension(file.type);
    if (this.email_msg_id) {
      const replace = this.email_msg_id.replace(/[.@<>]/g, '');
      name = name.replace(replace, '');
      name = name.slice(1);
    }
    if (name.split('.').length > 1) {
      return name;
    } else {
      return `${name}.${fileExtension}`;
    }
  }
  getFileIcon(extension): string {
    switch (extension) {
      case 'pdf':
        return 'fa fa-file-pdf-o';
      case 'doc':
      case 'docx':
        return 'fa fa-file-word-o';
      case 'xls':
      case 'xlsx':
        return 'fa fa-file-excel-o';
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
        this.isImage = true;
        return 'fa fa-file-image-o';
      case 'txt':
        return 'fa fa-file-text-o';
      case 'zip':
      case 'rar':
        return 'fa fa-file-archive-o';
      case 'mp3':
      case 'wav':
      case 'acc':
        return 'fa fa-file-audio-o';
      case 'mp4':
      case 'mov':
        return 'fa fa-file-video-o';
      default:
        return 'fa fa-file';
    }
  }
  getClassColor(extension) {
    switch (extension) {
      case 'pdf':
        return 'danger';
      case 'doc':
      case 'docx':
      case 'zip':
      case 'rar':
        return 'primary';
      case 'xls':
      case 'xlsx':
        return 'success';
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'mp3':
      case 'wav':
      case 'mp4':
      case 'mov':
        return 'warning';
      default:
        return '';
    }
  }

  downloadFile(): void {
    const link = document.createElement('a');
    this.fileService.downloadFile(this.fileUrl).subscribe(
      blob => {
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = this.fileName;
        link.click();
        window.URL.revokeObjectURL(url);
      },
      error => {
        link.href = this.fileUrl;
        link.rel = 'noreferrer';
        link.target = '_blank';
        link.download = this.fileName;
        link.click();
        console.error('Download failed:', error);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/file-viewer/file-viewer.component.ts